'use strict';

var $ = require('jquery');
var ViewportTracker = require('../lib/ViewportTracker.js');

/**
 * Enables a dropdown menu to open on focus and close once focus leaves.
 */
function init(containerSelector, activeClass, excludeState) {
	//* tst */console.log('init');
	var $container = $(containerSelector);
	if ($container.length === 0) {
		return;
	}
	
	function dropFocus(event) {
		if (!$container.is(event.target) && $container.has(event.target).length === 0) {
			$container.removeClass(activeClass);
			//$container.find(':input,select,a,span').each(function (index) {this.tabIndex = -1});
			$container.off('.containerFocusout');
		}
	}
	
	function open($elem) {
		//* tst */console.log('open');
		$container.removeClass(activeClass);
		$elem.addClass(activeClass);
		$(document).on('mouseup.containerFocusout focusin.containerFocusout', dropFocus);
	}
	
	function close($elem) {
		//* tst */console.log('close');
		$container.removeClass(activeClass);
		$container.off('.containerFocusout');
	}
	
	function isOpen($elem) {
		return $elem.hasClass(activeClass);
	}
	
	function handleToggle(event) {
		//* tst */console.log('handleToggle');
		event.preventDefault();
		var $parent = $(event.target).parents(containerSelector);
		//* tst */console.log($parent);
		if (isOpen($parent)) {
			close($parent);
		} else {
			open($parent);
		}
	}

	$container.on('click', '.inspirationFilter__currentValue', function(event) {
		//* tst */console.log('click', event.target);
		if (ViewportTracker.getState() !== excludeState) {
			handleToggle(event);
		}
	});
	
	// Open on space bar or enter
	$container.on('keyup', function(event) {
		if (event.target !== $container[0]) {
			return true;
		}
		if (event.which === 32 || event.which === 13) {
			handleToggle(event);
		}
	});
	
	// Open if an input inside 'more fields' receives focus
//	$container.children().on('focusin', function(event) {
//		if (!$container.hasClass(activeClass)) {
//			$(document).on('mouseup.containerFocusout focusin.containerFocusout', dropFocus);
//		}
//		open();
//	});
	
	// When surrounding form is submitted close 'more filters'
	$container.closest('form').on('submit', close);
}

module.exports = {
	init : init
};
